@if (etatPush === undefined || etatPush === "loading") {
  <div tuiAppearance="floating" tuiCardLarge class="pdf-card">
    <ngx-extended-pdf-viewer
      [src]="'assets/dep_page_1.pdf'"
      [showToolbar]="false"
      [(formData)]="formPdf"
      height="calc(100vh - 5rem - 3.5rem)"
    />
  </div>
}
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (valeurNonValidePourList()) {
    <div tuiAppearance="floating" tuiCardLarge>
      <h2>Valeur non valide pour :</h2>
      <ul>
        @for (champ of valeurNonValidePourList(); track $index) {
          <li>{{ champ }}</li>
        }
      </ul>
    </div>
  }
  @if (etatPush === undefined || etatPush === "loading") {
    <div tuiAppearance="floating" tuiCardLarge>
      <h2>Informations pratiques</h2>
      <tui-textfield>
        <label tuiLabel>Numéro de téléphone du patient *</label>
        <input formControlName="telephone" tuiTextfield />
        <tui-error
          formControlName="telephone"
          [error]="[] | tuiFieldError | async"
        />
      </tui-textfield>
    </div>
    <div tuiAppearance="floating" tuiCardLarge>
      <h2>Signature</h2>
      <section>
        <div tuiGroup [collapsed]="true">
          @if (patient?.canSign || (!patient && authService.getUser()?.rpps)) {
            <label tuiBlock (click)="selectMe()">
              Signer en mon nom
              <input
                formControlName="aSigner"
                tuiRadio
                type="radio"
                [value]="true"
                [style.margin-left]="'auto'"
              />
            </label>
          }
          <label tuiBlock>
            Préparer au nom de
            <input
              formControlName="aSigner"
              tuiRadio
              type="radio"
              [value]="false"
              [style.margin-left]="'auto'"
            />
          </label>
        </div>
        <tui-error
          formControlName="aSigner"
          [error]="[] | tuiFieldError | async"
        />
      </section>

      @if (this.form.get("aSigner")?.value == false) {
        <section>
          <tui-combo-box formControlName="medecin">
            Préparer au nom de
            <tui-data-list-wrapper
              *tuiDataList
              [items]="userList | tuiFilterByInput: matcherString"
            />
          </tui-combo-box>
          <tui-error
            formControlName="medecin"
            [error]="[] | tuiFieldError | async"
          />
        </section>
      }

      <div id="boutonEnregistrer">
        @if (this.form.get("aSigner")?.value) {
          <button tuiButton type="submit" [disabled]="etatPush === 'loading'">
            Editer et e-signer
          </button>
        } @else {
          <button
            tuiButton
            appearance="outline"
            tuiAppearanceMode="checked"
            type="submit"
            [disabled]="etatPush === 'loading'"
          >
            Editer sans e-signature
          </button>
        }
      </div>
    </div>
  } @else if (etatPush) {
    <div tuiAppearance="floating" tuiCardLarge class="statut-card">
      <tui-avatar
        appearance="positive"
        src="@tui.badge-check"
        tuiAnimated
        id="avatar-check"
      />
      <div tuiAnimated>
        Prescription éditée avec succès !
        @if (this.form.get("aSigner")?.value) {
          <br />
          <i
            >(signature électronique en cours, disponible dans quelques
            minutes)</i
          >
        }
      </div>
    </div>
  } @else {
    <div tuiAppearance="floating" tuiCardLarge class="statut-card">
      <tui-avatar appearance="error" src="@tui.badge-alert" tuiAnimated />
      <div tuiAnimated>Une erreur est survenue</div>
      <div id="boutonReessayer">
        <button
          tuiButton
          appearance="outline"
          tuiAppearanceMode="checked"
          (click)="initEtatPush()"
        >
          Réessayer
        </button>
      </div>
    </div>
  }
</form>
